import React from "react";
import { ArrowLeft, Home, Package, User } from "react-feather";
import { UserRoles } from "../core/enums/user-role.enum";

interface ISidebarItem {
  id?: any;
  title?: string;
  icon?: React.ReactNode;
  permissions?: Array<string>;
  path?: string;
  newTab?: boolean;
  children?: any;
}

interface ISidebarItemWithChilde extends ISidebarItem {
  children?: Array<ISidebarItem>;
}
export const NavigationConfig: Array<ISidebarItemWithChilde> = [
  {
    id: "dashboard",
    title: "داشبورد",
    path: "/",
    icon: <Home className="sidebar-icon" size={20} />,
    permissions: [UserRoles.UserReal, UserRoles.UserLegal],
  },
  {
    id: "ProductionSupplyPeriod",
    title: "دوره عرضه",
    permissions: [
      UserRoles.UserReal,
      UserRoles.UserLegal,
      UserRoles.UnionSecretariat,
    ],
    icon: <Package size={20} />,
    children: [
      {
        title: "کاربر",
        path: "/ProductionSupplyPeriod/User",
        permissions: [UserRoles.UserReal, UserRoles.UserLegal],
      },
      {
        title: "دبیرخانه",
        path: "/ProductionSupplyPeriod/Secretariat",
        permissions: [UserRoles.UnionSecretariat],
      },
    ],
  },
  {
    id: "back",
    title: " بازگشت به سامانه سبک",
    path: "/return",
    icon: <ArrowLeft className="sidebar-icon" size={20} />,
    permissions: [UserRoles.UserReal, UserRoles.UserLegal],
  },
];

export const navigationDetail = [
  {
    active: "/adminprovince",
    for: ["/adminprovince"],
  },
];
